import { Routes } from '@angular/router';
import { customerPortalGuard } from '../core/guards/customer-portal.guard';

export const authRoutes: Routes = [
  {
    path: 'login',
    canActivate: [customerPortalGuard],
    loadComponent: () => import('../auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register',
    canActivate: [customerPortalGuard],
    loadComponent: () => import('../auth/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [customerPortalGuard],
    loadComponent: () =>
      import('../auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    canActivate: [customerPortalGuard],
    loadComponent: () =>
      import('../auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
];
